module.exports = __webpack_public_path__ + "img/arrow.a56ca5a3.png";